module.exports = __webpack_public_path__ + "img/spinner_white.415673ce.svg";